export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7733.07b9db1d.jpg";